import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';
import { ColorSchemeDefinition } from './colorSchemes';

const breakpoints = {
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1920,
    },
};

export const createAppTheme = (
    scheme: ColorSchemeDefinition,
    isDark: boolean
): Theme => {
    const modeColors = isDark ? scheme.colors.dark : scheme.colors.light;

    const themeOptions: ThemeOptions = {
        breakpoints,
        palette: {
            mode: isDark ? 'dark' : 'light',
            primary: {
                main: modeColors.primary,
            },
            secondary: {
                main: modeColors.secondary,
            },
            background: isDark
                ? {
                    default: '#121212',
                    paper: '#1e1e1e',
                }
                : {
                    default: '#f4f6f8',
                    paper: '#ffffff',
                },
            text: isDark
                ? {
                    primary: '#ffffff',
                    secondary: '#b0b0b0',
                }
                : {
                    primary: '#333333',
                    secondary: '#888888',
                },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: '1rem',
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    colorDefault: {
                        backgroundColor: isDark ? '#1e1e1e' : modeColors.primary,
                        color: '#ffffff',
                    },
                },
            },
            ...(isDark && {
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none',
                        },
                    },
                },
            }),
        },
    };

    return createTheme(themeOptions);
};
